import { useState } from 'react'
import { CrwalTable } from './CrwalTable'
import { InputCard } from './InputFields'
import { QueryRequestProvider } from '../scrapping-table/core/QueryRequestProvider';
import { QueryResponseProvider } from '../scrapping-table/core/QueryResponseProvider';
import { ListViewProvider } from '../scrapping-table/core/ListViewProvider';
import { OutPutView } from './OutputView';

const MainScrapping = () => {

    const [isCrawling, setIsCrawling] = useState(false);
    const [tableLoading, setTableLoading] = useState(false);
    const [data, setData] = useState('');
    const [searchTerm, setSearchTerm] = useState<string>('')


    const setIsCrawlingValue = (value:boolean) => {
      setIsCrawling(value);
      setTableLoading(value);
    };
  
    return (
      <div>
        <InputCard isCrawling={isCrawling} handleCrawlClick={setIsCrawling} searchTerm={searchTerm} setSearchTerm={setSearchTerm}/>
        { !data ?  <CrwalTable tableLoading={tableLoading} handletableLoading={setTableLoading} fetchLoading={isCrawling} setDataHandler={setData}/> :
        <OutPutView data={data} clearData={setData}  websiteUrl={searchTerm}/> }
      </div>
    );
  };
 

const MainScrappingWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <MainScrapping />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {MainScrappingWrapper}
